<template>
    <div class="show-img">
        <img :src="params.data.fileManagers[0].url" class="rounded w-full img-checkin" />
<!--        <vs-popup class="showImg" :active.sync="zoomImage" title="Ảnh ghi nhận">-->
<!--            <img :src="params.data.fileManagers[0].url" alt="" class="zoomImage">-->
<!--        </vs-popup>-->
    </div>
</template>

<script>
export default {
    name: "CellRendererIcons",
    data() {
        return {
            zoomImage: false,
        }
    },
}
</script>

<style scoped>
.show-img .img-checkin {
    display: block;
    height: 65px;
    padding: 5px;
    width: 65px !important;
    /* object-fit: cover;
    object-position: center; */
    cursor: pointer;
}

.show-img {
    position: relative;
}

.zoomImage {
    width: 100%;
}
</style>
